<template>
  <div class="homepage">
    <div class="hotpage">
      <div class="toptitle">
        <div :class="recordstype=='new'?'active':''" @click="changeRecords('new',this)">最新内容</div>
        <div :class="recordstype=='hot'?'active':''" @click="changeRecords('hot',this)">热点文章</div>
        <div class="tomore" @click="goToMore()">更多>></div>
      </div>
      <div class="content"  v-loading="recordsloading">
        <div class="item" v-for="(item,index) in recordsData" :key='index'>
          <div class="title" @click="previewKmDoc(item)">{{item.title}}</div>
          <div class="time">[{{item.businessTypes_dictText?item.businessTypes_dictText+' ，':''}}{{item.createTime?item.createTime.substr(0,7):'--'}}]</div>
        </div>
        
      </div>
    </div>
    <div class="imgpage">
       <div class="righttitle">
        <div class="active">关键词共现图谱</div>
        <div class="tomore" @click="goToAtlas()">更多>></div>
      </div>
      <div class="content">
        <div class="chartcls">

          <chart-block ></chart-block>
        </div>
      </div>
    </div>
    <div class="downpage">
      <div class="righttitle">
        <div class="active">下载推荐</div>
        <div class="tomore" @click="goToMore()">更多>></div>
      </div>
      <div class="content">
        
        <div class="item"  v-for="(item,index) in downData" :key='index'>
          <div class="title" @click="previewKmDoc(item)">{{item.title}}</div>
          <div class="time"><i class="iconfont icon-xiazai1" @click="downloadKmDoc(item)"></i><span>[{{item.downloads}}]</span></div>
        </div>
      </div>
    </div>
    <div class="specialpage">
      <div class="righttitle">
        <div class="active">专题分类</div>
        <div class="tomore" @click="goToTheme()">更多>></div>
      </div>
      <div class="content">
        <el-tree
          :data="treedata.slice(0,10)"
          :props="defaultProps"
          accordion
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>
      <p-d-f-modal iframe-i-d="pdfIDde" :p-d-furl="PDFurl" :showmodel="showmodel" :title="pdftitle" @closepdfmodel='closePdfModel'/>
  </div>
</template>

<script>
import commonUrl from '@/assets/js/baseurl'
import api from "@/api/home.js"
import Vue from 'vue'
import Tree from 'element-ui';
  Vue.use(Tree);
import ChartBlock from '@/components/common/ChartsBlock.vue'
import PDFModal  from '@/components/common/PDFModal/index.vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    ChartBlock,
    PDFModal,
  },
  data() {
      return {
        treedata: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        recordsData:[],
        recordstype:'new',
        recordsloading:false,
        downData:[],
        url: {
          previewKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/previewKmDoc',
          downloadKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/downloadKmDoc',
        },
        PDFurl:'',
        pdftitle:'',
        showmodel:false,
      };
    },
    methods: {
      // 显示预览窗口，初始化
      previewKmDoc(record) {
        this.showmodel=true;
        console.log(record,123)
        this.PDFurl =  this.url.previewKmDoc + "?docId=" + record.id;
        this.pdftitle ='预览 - ' + record.name;
      },
      closePdfModel(){
        this.showmodel=false;

      },
      //下载文件
      downloadKmDoc(record) {
        this.$message.warning('文件开始下载');
        api.downloadFileName(this.url.downloadKmDoc, {docId: record.id},this.$message)
      },
      handleNodeClick(data) {
        console.log(data);
        this.$router.push({name:'ResearchUnit',params:{code:data.code,label:data.label}});
      },
      goToMore(){
        this.$router.push('/ResearchUnit');
        // this.$router.push({path:'/Theme',query:{setid:123456}}); //get
        // this.$router.push({name:'Theme',params:{setid:111222}});  //post
      },
      goToTheme(){
        this.$router.push('/Theme');
      },
      goToAtlas(){
        this.$router.push('/Atlas');
      },
      changeRecords(type){
        if(this.recordstype==type){
          return
        }
        this.recordstype=type
        this.getrecordsData()
      },
      getrecordsData(){
        this.recordsloading=true;
        //最新内容/热点文章
        if(this.recordstype=='new'){
          api.getlistRecently({
            column:'createTime',order:'desc',field:'id',pageNo:1,pageSize:10,statusList:2,
          }).then((res)=>{
            this.recordsloading=false;
            if(res.code==200&&res.result.records.length>0){
              this.recordsData=res.result.records
            }
          }).catch((err) => {
            console.log(err);
          });
        }else{
          api.getlistDraft({
            column:'views',order:'desc',field:'id',pageNo:1,pageSize:10,statusList:2,
          }).then((res)=>{
            this.recordsloading=false;
            if(res.code==200&&res.result.records.length>0){
              this.recordsData=res.result.records
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      },
      getdownData(){
        //下载推荐
        api.getlistDraft({
            column:'downloads',order:'desc',field:'id',pageNo:1,pageSize:10,statusList:2,
          }).then((res)=>{
            // console.log(res)
            if(res.code==200&&res.result.records.length>0){
              this.downData=res.result.records
            }
          }).catch((err) => {
            console.log(err);
          });
      },
      getloadTreeData(){
        //专题分类
        let params = {
          async: false,
          pcode: ""
        };
        api.getloadTreeData(params)
          .then((res)=>{
            // let treedatadiy=[]
            if(res.code==0&&res.result.length>0){
              this.treedata= this.diyTreeDataFn(res.result);
              this.treedata=this.treedata.slice(0,10)
            }
          }).catch((err) => {
            console.log(err);
          });
      },
      diyTreeDataFn(data){
        let that=this;
        let treearr=[]
        for(let i in data){
          if(data[i].children&&data[i].children.length>0){
            
            treearr.push({
              label: data[i].title,
              code:data[i].code,
              children:that.diyTreeDataFn(data[i].children)
            })
          }else{
            treearr.push({
              label: data[i].title,
              code:data[i].code
            })
          }
        }
          return treearr
      },
    },
  created(){
      this.getrecordsData();
      this.getdownData();
      this.getloadTreeData();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.homepage{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-bottom: 64px;
  .specialpage,.hotpage,.imgpage,.downpage{
    width: 576px;
    height: 412px;
    background: #FFFFFF;
    border: 1px solid #E6E6E6;
    margin-top: 16px;
    .toptitle{
      width: 552px;
      height: 47px;
      border-bottom: 1px solid #376EF4;
      margin: 0 auto;
      box-sizing: border-box;
      position: relative;
      &>div{
        width: 78px;
        height: 26px;
        line-height: 26px;
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        border-radius: 13px;
        font-size: 14px;
        font-weight: 400;
        color: #25365E;
        text-align: center;
        float: left;
        margin-left: 12px;
        margin-top: 13px;
        cursor: pointer;
      }
      &>div.active{
        background: #376EF4;
        color: #FFFFFF;
      }
      div.tomore{
        position: absolute;
        top: 12px;
        right: 0px;
        // width: 42px;
        height: 13px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        border: none;
        margin: 0;
      }
    }
    .righttitle{
      width: 552px;
      height: 47px;
      border-bottom: 1px solid #376EF4;
      margin: 0 auto;
      box-sizing: border-box;
      padding-left: 12px;
      position: relative;
      div.active{
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 47px;
        position: relative;
        padding-left: 9px;
      }
      div.active:before{
        content: '';
        display: inline-block;
        width: 3px;
        height: 14px;
        line-height: 47px;
        background: #376EF4;
        border-radius: 2px;
        margin-right: 9px;
        position: absolute;
        top:16px;
        left: 0;
      }
      div.tomore{
        position: absolute;
        top: 16px;
        right: 12px;
        // width: 42px;
        height: 13px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }
    }
    .content{
      width: 530px;
      margin-left: 24px;
      min-height: 120px;
      padding-top: 12px;
      .item{
        height: 33px;
        border-bottom: 1px dotted #E6E6E6;
        display: flex;
        justify-content: space-between;
        .title{
          // float: left;
          width: 60%;
          font-size: 14px;
          line-height: 33px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          position: relative;
          padding-left: 12px;
          overflow: hidden;  //超出隐藏
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //溢出显示省略号
        cursor: pointer;
        }
        .title:before{
          width: 4px;
          height: 4px;
          background: #CCCCCC;
          border-radius: 50%;
          margin-right: 8px;
          display: block;
          content: '';
          border-radius: 50%;
          position: absolute;
          top: 14px;
          left: 0px;
        }
        .time{
          // float: right;
          text-align: right;
          width: 36%;
          font-size: 14px;
          line-height: 33px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #B3B3B3;
          overflow: hidden;  //超出隐藏
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //溢出显示省略号
        }
        .icon-xiazai1{
          // font-size: 12px;
          margin-right: 3px;
          cursor: pointer;
        }
      }
    }
  }
  .specialpage{
    height: auto;
    
    .content{
      margin-left: 12px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      padding-bottom: 20px;
    }
  }
  .imgpage{
    .chartcls{
      width: 530px;
      height: 360px;
    }
  }
}
</style>
